"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("@material-ui/core/styles/makeStyles");
var financeCalculatorContainerStyles = makeStyles_1.default(function (theme) {
    var _a;
    return ({
        closeIcon: {
            cursor: 'pointer',
            width: '20px',
            height: '20px',
        },
        finCalc: (_a = {
                position: 'relative',
                borderBottomLeftRadius: 30,
                borderBottomRightRadius: 30,
                // Increase specificity.
                '&:not(:disabled)': {
                    padding: 0,
                    width: '100%',
                    minHeight: '70vh',
                }
            },
            _a[theme.breakpoints.up('md')] = {
                maxWidth: '720px',
                minHeight: '50rem',
            },
            _a[theme.breakpoints.down('xs')] = {
                borderRadius: 0,
            },
            _a),
    });
}, { name: 'Common_FinanceCalculatorContainer' });
exports.default = financeCalculatorContainerStyles;
